module.exports = __webpack_public_path__ + "static/media/about-5.64412d88.jpg";